import { IDENTITY_CONFIG, METADATA_OIDC } from "../../libs/authConst";
import AppConst from 'libs/appconst';
import AuthService from 'services/auth/auth-service';
import { getStorage, setStorage } from 'utils/storage-utils';
import { UserManager, WebStorageStateStore, Log } from "oidc-client";

export default class OidcAuthService {
    UserManager;

    constructor() {
        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            metadata: {
                ...METADATA_OIDC
            }
        });
        // Logger
        //Log.logger = console;
        //Log.level = Log.DEBUG;
        this.UserManager.events.addUserLoaded((user) => {
            if (window.location.href.indexOf("signin-oidc") !== -1) {
                var expiredDuration = (365 * 24 * 60 * 60);
                setStorage("access_token", user.access_token, expiredDuration); //expired 365 days
                AuthService.GetUserByToken().then(res => {
                    setStorage("user", JSON.stringify(res.result), expiredDuration); //expired 365 days
                    this.navigateToScreen();
                }).finally(() => {
                    this.navigateToScreen();
                });
            }
        });
        this.UserManager.events.addSilentRenewError((e) => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.signinSilent();
        });
    }

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then(function (user) {
        }).catch(err => {
            console.log("ERROR " + err);
            console.log("ERROR Detail " + err.message);
            if (err.message == "No matching state found in storage") {
                localStorage.clear();
                this.UserManager.clearStaleState();
                window.location = "/logout";
            }
            if (err.message.includes("iat is in the future")) {
                alert("Jam perangkat Anda tidak up to date. Silahkan lakukan penyetelan ulang jam perangkat Anda.");
                window.location = "/logout";
            }
        });
    };


    getUser = async () => {
        const user = await this.UserManager.getUser();
        //if (!user) {
        //    return await this.UserManager.signinRedirectCallback();
        //}

        var access_token = getStorage("access_token");
        if (!access_token) {
            var expiredDuration = (365 * 24 * 60 * 60);
            setStorage("access_token", user.access_token, expiredDuration); //expired 365 days
        }

        return user;
    };

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };


    signinRedirect = () => {
        localStorage.setItem("redirectUri", window.location.pathname + window.location.search);
        this.UserManager.signinRedirect({}).catch(err => {
            console.log(err);
        });
    };


    signinRedirectWithParam = (isRegister, affiliateId) => {
        localStorage.setItem("redirectUri", window.location.pathname + window.location.search);
        this.UserManager.signinRedirect({ extraQueryParams: { showRegister: isRegister, affiliateId: affiliateId } }).catch(err => {

        });
    };


    navigateToScreen = () => {
        var redirectUri = localStorage.getItem("redirectUri");
        window.location.replace(redirectUri);
    };


    isAuthenticated = () => {
        const oidcStorage = JSON.parse(localStorage.getItem(`oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`));
        var isAuthenticated = (!!oidcStorage && !!oidcStorage.access_token);
        return isAuthenticated;
    };

    isAuthenticatedByCookie = () => {
        var logosCookies = document.cookie.match(new RegExp('(^| )' + "logosisauth.logoswebapp" + '=([^;]+)'));
        if (logosCookies) {
            var logosCookie = logosCookies[2];
            var isAuthenticated = logosCookie == "true";
            return isAuthenticated;
        }
        return false;
    };

    signinSilent = () => {
        return this.UserManager.signinSilent()
            .then((user) => {
                debugger;
                var expiredDuration = (365 * 24 * 60 * 60);
                setStorage("access_token", user.access_token, expiredDuration); //expired 365 days
                return user.access_token;
            })
            .catch((err) => {
                console.log(err);
                window.location = "/logout";
                throw err;
            });
    };

    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        });
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            window.location.replace(AppConst.Logos_APPURL);
        });
        this.UserManager.clearStaleState();
    };
}